import React from "react";
import { useSearchParams } from "react-router-dom";

export function useQueryParamState(name: string | undefined | null): [string | null, (value: string | number | null) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = name ? searchParams.get(name) : null;

  const setValue = React.useCallback(
    (nextValue: string | number | null) => {
      if (!name) {
        return;
      }

      setSearchParams((current) => {
        const next = new URLSearchParams(current);

        if (nextValue === null || nextValue === undefined || nextValue === "") {
          next.delete(name);
        } else {
          next.set(name, String(nextValue));
        }

        return next;
      });
    },
    [name, setSearchParams]
  );

  return [value, setValue];
}
